import { useState, useEffect,useContext } from "react"
import styles from "./ConstantRegister.module.css"
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthContext, AuthContextType } from "../../Auth";
import { baseUrl } from "../../url";


export type productData = {
    product_id: number;
    productname: string;
    manufacture: string;
    moldingsite: string;
    supplier: string;
    cost: number;
    leftright: string[];
    size: string[];
    color: string[];
    product_type: string;
    base_price?: number;
}

type kind = {
    leftright: string;
    size: string;
    color: string;
    constant: number;
    office: string;
}

export default function ConstantRegister() {
    const navigate = useNavigate();

    
    const [selectManufacture, setSelectManufacture] = useState<string[]>([]);
    const [selectedManufacture, setSelectedManufacture] = useState<string>("");
    const [products, setProducts] = useState<productData[]>([]);
    const [selectedProduct, setSelectedProduct] = useState<string>("");
    const [productData, setProductData] = useState<productData>();
    const [kinds, setKinds] = useState<kind[]>([]);
    const { auth,setAuth } = useContext(AuthContext) as AuthContextType;
    const [selectedOffice, setSelectedOffice] = useState<string>(auth.office?auth.office:"函館店");

    useEffect(() => {
 const checkAuth = async () => {
            try {
                    const response = await fetch(`${baseUrl}/checkAuth`, {
                    method: "POST",
                    credentials: "include",
                    headers: { 'Content-Type': 'application/json' },
                })
                const data = await response.json();
                if (!data.result) {
                    console.log("Not authenticated");
                   setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
                   return navigate("/login");
                }
                        const response2 = await fetch(`${baseUrl}/getusersdata`,{
                        method: "POST",
                        credentials: "include",
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ username: data.username })
                    })
                    const data2 = await response2.json();
                    console.log("Authenticated user:", data.username, "Office:", data2.office,"Authority:",data2.authority);
                    setAuth({ username: data.username, isAuthenticated: true, office: data2.office,authority:data2.authority });
                } catch (error) {
                console.error(error);
            }
        }
        checkAuth();

        const fetchSelectInit = async () => {
            const response = await fetch(`${baseUrl}/getmanufacture`,{
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if(data.isAuth===false){
            return;
        }
            const Manufactures = data.manufacture.map((item: Object) => Object.values(item))
            setSelectManufacture(Manufactures);
        }
        fetchSelectInit();
    }, [navigate, setAuth])

    useEffect(() => {
        const fetchSelectProducts = async () => {
            const response = await fetch(`${baseUrl}/getproducts`, {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                credentials: "include",
                body: JSON.stringify({
                    "manufacture": selectedManufacture
                })
            })
            const data = await response.json();
            if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
            setProducts(data);
        }

        fetchSelectProducts();

    }, [selectedManufacture, navigate,setAuth]);

    const handleOffice = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedOffice(e.target.value);
    }

    const handleManufacture = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedManufacture(e.target.value);
    }

    const handleProducts = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setSelectedProduct(e.target.value)
    }

    const constantRender = async () => {
        const selectedProductData = products.find(item=>item.productname===selectedProduct)
        const product_id= selectedProductData?.product_id;
        const response = await fetch(`${baseUrl}/productdata`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                "product_id": product_id
            })
        })
        const data = await response.json();
        if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
        setProductData(data);

        if (data === undefined) {
            alert("製品データが確認できません。")
            return;
        }

        let Kinds: kind[] = [];

        for (let i = 0; data.color.length > i; i++) {
            for (let j = 0; data.leftright.length > j; j++) {
                for (let k = 0; data.size.length > k; k++) {
                    let Kind: kind = {
                        leftright: data.leftright[j],
                        size: data.size[k],
                        color: data.color[i],
                        constant: 0,
                        office: selectedOffice
                    };
                    Kinds.push(Kind);
                }
            }
        }
        setKinds(Kinds);
    }

    const increment = (index: number) => {
        const newKind = { ...kinds[index], constant: kinds[index].constant + 1 };
        const newKinds = [...kinds];
        newKinds.splice(index, 1, newKind);
        setKinds(newKinds);
    }
    const decrement = (index: number) => {
        const newKind = { ...kinds[index], constant: kinds[index].constant - 1 };
        const newKinds = [...kinds];
        newKinds.splice(index, 1, newKind);
        setKinds(newKinds);
    }

    const constantPush = async () => {
        const selectedProductData = products.find(item=>item.productname===selectedProduct)
        const product_id = selectedProductData?.product_id;
        const response = await fetch(`${baseUrl}/constantpush`, {
            method: "POST",
            credentials: "include",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                "product_id": product_id,
                "kinds": kinds,
            })
        })
        const data = await response.json();
        if(data.isAuth===false){
            alert("セッションが切れました。再度ログインしてください");
            setAuth({ username: null, isAuthenticated: false, office: undefined, authority:"user" });
            return navigate("/login");}
        console.log(data);
        navigate("/Constant");
    }


    return (
        <div className={styles.div}>
            {auth.office? <p className={styles.p2}>{auth.office}</p>:<div><p>定数を追加する支店を選択してください。</p>
                <select value={selectedOffice} onChange={handleOffice} className={styles.select}>
                    <option value="函館店">函館店</option>
                    <option value="札幌店">札幌店</option>
                    <option value="釧路店">釧路店</option>
                    <option value="室蘭店">室蘭店</option>
                </select>
            </div>}
            <div className={styles.selectwrapper}>
                <select value={selectedManufacture} onChange={handleManufacture} className={styles.select}>
                    <option value="">未設定</option>
                    {selectManufacture.map(item => (<option key={item} value={item}>{item}</option>))}
                </select>
                <select value={selectedProduct} onChange={handleProducts} className={styles.select}>
                    <option value="">未設定</option>
                    {products.map((item, index) => (<option key={index} value={item.productname}>{item.productname}</option>))}
                </select>
                <Button onClick={constantRender} variant="contained" sx={{ fontSize: 16, "@media screen and (max-width:959px)": { fontSize: 14 } }}>選択した製品のリストを表示する</Button>
            </div>

            {(productData === undefined || !productData) ? (<p>定数を設定する製品が選択されていません。</p>) :

                (<div className={styles.div2}><Button onClick={constantPush} variant="contained" sx={{ fontSize: 16, "@media screen and (max-width:959px)": { fontSize: 14 } }}>定数を反映する</Button>
                    <p className={styles.p}>すでに定数が設定されている製品は定数が上書きされます。</p>
                    <div className={styles.scroll}>
                        <table className={styles.table}>
                            <thead>
                                <tr>
                                    <th className={styles.th}>製品名</th>
                                    <th className={styles.th}>色</th>
                                    <th className={styles.th}>左右</th>
                                    <th className={styles.th}>サイズ</th>
                                    <th className={styles.th}>在庫定数</th>
                                    <th className={styles.th} colSpan={2}>在庫定数の変更</th>
                                </tr>
                            </thead>
                            <tbody>
                                {kinds.map((item, index) => (
                                    <tr key={index}>
                                        <td className={styles.td}>{productData.productname}</td>
                                        <td className={styles.td}>{item.color}</td>
                                        <td className={styles.td}>{item.leftright}</td>
                                        <td className={styles.td}>{item.size}</td>
                                        <td className={styles.td2}>{item.constant}</td>
                                        <td ><Button key={index} onClick={() => increment(index)} variant="contained" sx={{ fontSize: 16, "@media screen and (max-width:959px)": { fontSize: 12 } }}>+1</Button></td>
                                        <td ><Button key={index} onClick={() => decrement(index)} disabled={item.constant < 1} variant="contained" sx={{ fontSize: 16, "@media screen and (max-width:959px)": { fontSize: 12 } }}>-1</Button></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table></div></div>)}
        </div>
    )
}